
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dsz8u", function(module, exports) {
/**
 * @generated SignedSource<<45ffa2b3ed57a4f832d4c644f0f5907e>>
 * @relayHash a3f93252d4df99f3c4003e78531fafc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df71df8a37a95b7e01d466a726b850da583995644da0b9c4c2b9125587744508
const $098c1471e98b529c$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "CopySpacePermissionsSelectorQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "CopySpacePermissionsSelectorQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a3f93252d4df99f3c4003e78531fafc9",
            "id": "df71df8a37a95b7e01d466a726b850da583995644da0b9c4c2b9125587744508",
            "metadata": {},
            "name": "CopySpacePermissionsSelectorQuery",
            "operationKind": "query",
            "text": "query CopySpacePermissionsSelectorQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$098c1471e98b529c$var$node.hash = "868b6122e320d9d148ec3df40d58a181";
var $098c1471e98b529c$export$2e2bcd8739ae039 = $098c1471e98b529c$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");


var $inPa6 = parcelRequire("inPa6");


var $2VHSy = parcelRequire("2VHSy");


var $eJhXX = parcelRequire("eJhXX");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $6H6bO = parcelRequire("6H6bO");


var $crGnL = parcelRequire("crGnL");







var $hiS1z = parcelRequire("hiS1z");

var $cs1vW = parcelRequire("cs1vW");


var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $6xdDU = parcelRequire("6xdDU");


var $gxbof = parcelRequire("gxbof");


var $iquRY = parcelRequire("iquRY");


var $4PPzL = parcelRequire("4PPzL");


var $TCbX7 = parcelRequire("TCbX7");


var $9wGTI = parcelRequire("9wGTI");








var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

const $3e3b50d0439aeed6$var$optionStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    flexDirection: 'column'
});
const $3e3b50d0439aeed6$export$22ef38b3d0b0f282 = ({ label: label, description: description, isSelected: isSelected, isMenu: isMenu, isRbacEnabled: isRbacEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $3e3b50d0439aeed6$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        weight: !isMenu && isRbacEnabled ? 'bold' : 'regular'
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        color: isSelected ? 'color.text.subtle' : 'color.text.subtlest',
        size: "small"
    }, description));



var $4xjqG = parcelRequire("4xjqG");

const $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE = '';
const $afd0d04d210c004f$var$formatOptionLabel = (option, { context: context, selectValue: selectValue }, isRbacEnabled)=>{
    if (context === 'menu') {
        const selected = selectValue?.[0]?.value;
        const isSelected = selected ? selected === option.value : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e3b50d0439aeed6$export$22ef38b3d0b0f282), {
            label: option.label,
            description: option.description,
            isSelected: isSelected,
            isMenu: true,
            isRbacEnabled: isRbacEnabled
        });
    } else if (isRbacEnabled) {
        const selected = selectValue?.[0]?.value;
        const isSelected = selected ? selected === option.value : false;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3e3b50d0439aeed6$export$22ef38b3d0b0f282), {
            label: option.label,
            description: option.description,
            isSelected: isSelected,
            isMenu: false,
            isRbacEnabled: isRbacEnabled
        });
    } else return option.label;
};
const $afd0d04d210c004f$var$getOptionLabel = (option)=>{
    return `${option.label} ${option.description}`;
};
const $afd0d04d210c004f$export$3e92eb7b7644ac65 = (props)=>{
    const { data: data, innerProps: innerProps, innerRef: innerRef } = props;
    return data.alternateComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: innerRef,
        ...innerProps
    }, data.alternateComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props);
};
const $afd0d04d210c004f$var$CopySpacePermissionsUpsellEndUserRequestModal = ({ showModal: showModal, setShowModal: setShowModal, setRequestUpgradeButtonIsLoading: setRequestUpgradeButtonIsLoading, source: source })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: "growth-luna"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: ()=>setShowModal(false),
        setIsLoadingModal: setRequestUpgradeButtonIsLoading
    })));
const $afd0d04d210c004f$export$bcd24b8f826ea9a2 = (0, $h82at.defineMessages)({
    placeholder: {
        id: "copy-space-permissions.selector.placeholder",
        defaultMessage: "Select an option"
    },
    defaultPermissions: {
        id: "copy-space-permissions.selector.items.default",
        defaultMessage: "Default permissions"
    },
    defaultPermissionsDescription: {
        id: "copy-space-permissions.selector.items.default.description",
        defaultMessage: "Use the space permissions set by your admin"
    },
    default: {
        id: "copy-space-permissions.selector.items.default-roles",
        defaultMessage: "Default"
    },
    defaultDescription: {
        id: "copy-space-permissions.selector.items.default-roles.description",
        defaultMessage: "Use the access settings recommended by your admin"
    },
    onlyVisibleToMe: {
        id: "copy-space-permissions.selector.items.private",
        defaultMessage: "Only visible to me"
    },
    onlyVisibleToMeDescription: {
        id: "copy-space-permissions.selector.items.private.description",
        defaultMessage: "Only you can view this space"
    },
    restricted: {
        id: "copy-space-permissions.selector.items.restricted",
        defaultMessage: "Restricted"
    },
    restrictedDescription: {
        id: "copy-space-permissions.selector.items.restricted.description",
        defaultMessage: "Only you have access until you add others"
    },
    copyPermissions: {
        id: "copy-space-permissions.selector.items.copy.from.existing.space",
        defaultMessage: "Copy permissions from another space"
    },
    copyPermissionsDescription: {
        id: "copy-space-permissions.selector.items.copy.from.existing.space.description",
        defaultMessage: "Use the permissions from a similar space"
    },
    copyAccess: {
        id: "copy-space-permissions.selector.items.copy.access",
        defaultMessage: "Copy access settings"
    },
    copyAccessDescription: {
        id: "copy-space-permissions.selector.items.copy.access.description",
        defaultMessage: "Use another space\u2019s settings"
    }
});
const $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace = (0, $h82at.defineMessages)({
    title: {
        id: "copy-space-permissions.for-new-space.upsell.title",
        defaultMessage: "Setting up permissions can be faster than ever"
    },
    body: {
        id: "copy-space-permissions.for-new-space.upsell.description",
        defaultMessage: "Quickly copy your unique permissions from another space with Premium."
    }
});
const $afd0d04d210c004f$var$OptionSelectComponent = ({ analyticsEventSourceName: analyticsEventSourceName, options: options, defaultValue: defaultValue, intl: intl, label: label, onChange: onChange, onMenuOpen: onMenuOpen, showUpsell: showUpsell, value: value, isDisabled: isDisabled, fullWidth: fullWidth, inputId: inputId })=>{
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const [requestUpgradeButtonIsLoading, setRequestUpgradeButtonIsLoading] = (0, $42omo.useState)(false);
    const handleRequestUpgradeButtonClick = ()=>{
        setRequestUpgradeButtonIsLoading(true);
        setShowModal(true);
    };
    const optionList = [
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.onlyVisibleToMe),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.onlyVisibleToMeDescription),
            value: (0, $crGnL.Option).ONLY_VISIBLE_TO_ME
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultPermissions),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultPermissionsDescription),
            value: (0, $crGnL.Option).DEFAULT_PERMISSIONS
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyPermissions),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyPermissionsDescription),
            value: (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE
        },
        {
            label: '',
            value: $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE,
            alternateComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gxbof.CopySpacePermissionsUpsell), {
                source: analyticsEventSourceName,
                messages: $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading,
                onRequestUpgradeButtonClick: handleRequestUpgradeButtonClick
            }),
            isDisabled: true
        }
    ];
    //TODO: Update the restricted options when RBAC is released
    const descriptiveOptionList = [
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.default),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.defaultDescription),
            value: (0, $crGnL.Option).DEFAULT_PERMISSIONS
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyAccess),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.copyAccessDescription),
            value: (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE
        },
        {
            label: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.restricted),
            description: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.restrictedDescription),
            value: (0, $crGnL.Option).ONLY_VISIBLE_TO_ME
        },
        {
            label: '',
            value: $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE,
            alternateComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gxbof.CopySpacePermissionsUpsell), {
                source: analyticsEventSourceName,
                messages: $afd0d04d210c004f$var$copySpacePermissionsUpsellMessagesForNewSpace,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading,
                onRequestUpgradeButtonClick: handleRequestUpgradeButtonClick
            }),
            isDisabled: true
        }
    ];
    const availableOptions = isRbacEnabled ? descriptiveOptionList.filter(({ value: value })=>// Only show the UpSell option (whose `value` is `OPTION_NOT_SELECTABLE_VALUE`) if UpSell is enabled
        value === $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE ? showUpsell : options.indexOf(value) !== -1) : optionList.filter(({ value: value })=>// Only show the UpSell option (whose `value` is `OPTION_NOT_SELECTABLE_VALUE`) if UpSell is enabled
        value === $afd0d04d210c004f$var$OPTION_NOT_SELECTABLE_VALUE ? showUpsell : options.indexOf(value) !== -1);
    const onSelectMenuOpen = ()=>{
        if (typeof onMenuOpen === 'function') onMenuOpen();
    };
    const onSelectChange = (selection)=>{
        if (typeof onChange === 'function') onChange(selection.value);
    };
    const select = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        classNamePrefix: "option-select",
        components: {
            Option: $afd0d04d210c004f$export$3e92eb7b7644ac65
        },
        defaultValue: availableOptions.find((option)=>option.value === defaultValue),
        formatOptionLabel: (option, meta)=>$afd0d04d210c004f$var$formatOptionLabel(option, meta, isRbacEnabled),
        getOptionLabel: $afd0d04d210c004f$var$getOptionLabel,
        id: "copy-space-perms-option-select",
        isDisabled: isDisabled || availableOptions.length === 1,
        maxMenuHeight: 350,
        onChange: onSelectChange,
        onMenuOpen: onSelectMenuOpen,
        options: availableOptions,
        placeholder: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.placeholder),
        // @ts-ignore this prop doesn't seem to be defined
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4xjqG.customSelectStyles)(fullWidth),
        value: availableOptions.find((option)=>option.value === value),
        inputId: inputId,
        isSearchable: false
    });
    const optionSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        classNamePrefix: "option-select",
        components: {
            Option: $afd0d04d210c004f$export$3e92eb7b7644ac65
        },
        defaultValue: availableOptions.find((option)=>option.value === defaultValue),
        formatOptionLabel: (option, meta)=>$afd0d04d210c004f$var$formatOptionLabel(option, meta, isRbacEnabled),
        getOptionLabel: $afd0d04d210c004f$var$getOptionLabel,
        id: "copy-space-perms-option-select",
        isDisabled: isDisabled || availableOptions.length === 1,
        maxMenuHeight: 350,
        onChange: onSelectChange,
        onMenuOpen: onSelectMenuOpen,
        options: availableOptions,
        placeholder: intl.formatMessage($afd0d04d210c004f$export$bcd24b8f826ea9a2.placeholder),
        // @ts-ignore this prop doesn't seem to be defined
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4xjqG.customSelectStyles)(fullWidth),
        value: availableOptions.find((option)=>option.value === value),
        inputId: inputId,
        isSearchable: false
    });
    const selectComponent = isRbacEnabled ? optionSelect : select;
    const selectComponentWithLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xjqG.SelectLabel), {
        htmlFor: "copy-space-perms-option-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), label)), selectComponent);
    const component = label ? selectComponentWithLabel : selectComponent;
    return (0, $9wGTI.fg)('twcg-1169_ceurs2p_createspacedrawer_fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($afd0d04d210c004f$var$CopySpacePermissionsUpsellEndUserRequestModal, {
        showModal: showModal,
        setShowModal: setShowModal,
        setRequestUpgradeButtonIsLoading: setRequestUpgradeButtonIsLoading,
        source: analyticsEventSourceName
    }), component) : component;
};
const $afd0d04d210c004f$export$6bab038dd5186918 = (0, $cs1vW.default)($afd0d04d210c004f$var$OptionSelectComponent);



var $lsPeB = parcelRequire("lsPeB");




const $0fd2af518e91029a$var$CopySpacePermissionsSelectorQuery = (0, $098c1471e98b529c$export$2e2bcd8739ae039);
const $0fd2af518e91029a$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    sourceSpaceSelectorPlaceholder: {
        id: "copy-space-permissions.space-selector.placeholder",
        defaultMessage: "Choose a space"
    },
    sourceSpaceSelectorLabel: {
        id: "copy-space-permissions.space-selector.prompt",
        defaultMessage: "Copy from"
    }
});
const $0fd2af518e91029a$export$657dee6d5648750a = {
    isRestricted: false,
    containsExternalCollaborators: false,
    key: '',
    name: '',
    isAdmin: false,
    id: ''
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0fd2af518e91029a$var$FlexRow = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
function $0fd2af518e91029a$export$327bf7ab4c0b09c9({ analyticsEventSourceName: analyticsEventSourceName, defaultOption: defaultOption, defaultSpaceKey: defaultSpaceKey, isDisabled: isDisabled, label: label, onChange: onChange, options: options, showUpsell: showUpsell, filterSourceSpaceOptions: filterSourceSpaceOptions, sourceSpaceSelectorValidationState: sourceSpaceSelectorValidationState = 'default', renderGuestsWarning: renderGuestsWarning, fullWidth: fullWidth, validationPlaceholder: validationPlaceholder, optionSelectInputId: optionSelectInputId, allowOnlyAdminSpaces: allowOnlyAdminSpaces }) {
    const [option, setOption] = (0, $42omo.useState)(defaultOption);
    const [sourceSpace, setSourceSpace] = (0, $42omo.useState)($0fd2af518e91029a$export$657dee6d5648750a); /* Bind createAnalyticsEvent to the event Source, edition, and userPrivilege so that these two pieces of
                                                                                                   data go out with all analytics events */ 
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($0fd2af518e91029a$var$CopySpacePermissionsSelectorQuery);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useMemo)(()=>{
        const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(data);
        return (0, $2VHSy.createAnalyticsEventFactory)(createAnalyticsEvent, analyticsEventSourceName, {
            ...edition && {
                edition: edition
            },
            ...userPrivilege && {
                userPrivilege: userPrivilege
            }
        });
    }, [
        analyticsEventSourceName,
        createAnalyticsEvent,
        data,
        edition
    ]);
    const onCopySpacePermissionsOptionMenuOpen = ()=>{
        (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.OPTION_SELECT_ACTION_SUBJECT), (0, $6H6bO.OPTION_SELECT_DROPDOWN_OPEN_ACTION_SUBJECT_ID));
    };
    const onCopySpacePermissionsOptionChange = (option)=>{
        setOption(option); // Always clear the source Space Key, as the SpaceSelector has no initial selection
        if (sourceSpace !== $0fd2af518e91029a$export$657dee6d5648750a) setSourceSpace($0fd2af518e91029a$export$657dee6d5648750a);
        (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.OPTION_SELECT_ACTION_SUBJECT), (0, $6H6bO.getEventActionSubjectId)(option));
        onChange({
            option: option,
            sourceSpace: $0fd2af518e91029a$export$657dee6d5648750a
        });
    };
    const onSpacePermissionsSourceChange = ({ isRestricted: isRestricted, containsExternalCollaborators: containsExternalCollaborators, spaceKey: spaceKey, spaceName: spaceName, isAdmin: isAdmin, id: id })=>{
        if (sourceSpace.key !== spaceKey || sourceSpace.name !== spaceName) {
            const nextSourceSpace = {
                isRestricted: isRestricted,
                containsExternalCollaborators: containsExternalCollaborators,
                isAdmin: isAdmin,
                key: spaceKey,
                name: spaceName,
                id: id
            };
            setSourceSpace(nextSourceSpace);
            (0, $6H6bO.fireUIClickEvent)(wrappedCreateAnalyticsEvent, (0, $6H6bO.SOURCE_SPACE_SELECT_ACTION_SUBJECT), (0, $6H6bO.SOURCE_SPACE_SELECTED_SUBJECT_ID));
            onChange({
                option: option,
                sourceSpace: nextSourceSpace
            });
        }
    };
    const isSourceSpaceInvalid = !$0fd2af518e91029a$export$8764bbb8a782240c({
        option: option,
        sourceSpace: sourceSpace,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces
    });
    if (sourceSpaceSelectorValidationState === 'default' && sourceSpace !== $0fd2af518e91029a$export$657dee6d5648750a && isSourceSpaceInvalid) // DON'T show a validation error if the user has not selected a space yet
    // even though no space selected is an invalid state:
    sourceSpaceSelectorValidationState = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0fd2af518e91029a$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $afd0d04d210c004f$export$6bab038dd5186918), {
        analyticsEventSourceName: analyticsEventSourceName,
        isDisabled: isDisabled,
        label: label,
        onChange: onCopySpacePermissionsOptionChange,
        onMenuOpen: onCopySpacePermissionsOptionMenuOpen,
        options: options,
        showUpsell: showUpsell,
        value: option,
        fullWidth: fullWidth,
        inputId: optionSelectInputId
    })), option === (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xjqG.LabeledSelect), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lsPeB.SourceSpaceSelector), {
        onChange: onSpacePermissionsSourceChange,
        label: label ? $0fd2af518e91029a$export$a7357cdd1f0b0168.sourceSpaceSelectorLabel : undefined,
        placeholder: $0fd2af518e91029a$export$a7357cdd1f0b0168.sourceSpaceSelectorPlaceholder,
        validationState: sourceSpaceSelectorValidationState,
        filterSourceSpaceOptions: filterSourceSpaceOptions,
        renderGuestsWarning: renderGuestsWarning,
        fullWidth: fullWidth,
        validationPlaceholder: validationPlaceholder,
        defaultSpaceKey: defaultSpaceKey,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces,
        showSpaceLabel: true,
        labelTextTransform: "none"
    })) : null);
}
function $0fd2af518e91029a$export$8764bbb8a782240c({ option: option, sourceSpace: sourceSpace, allowOnlyAdminSpaces: allowOnlyAdminSpaces, targetSpaceKey: targetSpaceKey }) {
    return option != (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE || sourceSpace && Boolean(sourceSpace.key) && !sourceSpace.isRestricted && (allowOnlyAdminSpaces ? sourceSpace.isAdmin : true) && (targetSpaceKey === undefined || targetSpaceKey !== sourceSpace.key);
}
module.exports["EMPTY_SPACE"] = $0fd2af518e91029a$export$657dee6d5648750a;
module.exports["CopySpacePermissionsSelector"] = $0fd2af518e91029a$export$327bf7ab4c0b09c9;
module.exports["isSourceSpaceValid"] = $0fd2af518e91029a$export$8764bbb8a782240c;

});

parcelRegister("6H6bO", function(module, exports) {

var $crGnL = parcelRequire("crGnL");

const $4dd7cabfb97762a1$export$c2f50b86729b5b74 = 'selectDropdown';
const $4dd7cabfb97762a1$export$fedfc172a3b39723 = 'spaceSelect';
const $4dd7cabfb97762a1$export$79fc012ce0853550 = 'button';
const $4dd7cabfb97762a1$export$44e673763b6e05ef = 'copySpacePermissionsSpacePermissionsDropdownOpen';
const $4dd7cabfb97762a1$export$a964296cb5c0acac = 'copySpacePermissionsCopyFromExisting';
const $4dd7cabfb97762a1$export$d9caa862be38cd79 = 'copySpacePermissionsUseDefaults';
const $4dd7cabfb97762a1$export$648a702396c42939 = 'copySpacePermissionsMakePrivate';
// Translates an option selected from the CSP Option Select control into Action Subject ID:
const $4dd7cabfb97762a1$var$OptionToEventActionSubjectIdMap = new Map([
    [
        (0, $crGnL.Option).ONLY_VISIBLE_TO_ME,
        $4dd7cabfb97762a1$export$648a702396c42939
    ],
    [
        (0, $crGnL.Option).DEFAULT_PERMISSIONS,
        $4dd7cabfb97762a1$export$d9caa862be38cd79
    ],
    [
        (0, $crGnL.Option).COPY_PERMISSIONS_FROM_ANOTHER_SPACE,
        $4dd7cabfb97762a1$export$a964296cb5c0acac
    ]
]);
const $4dd7cabfb97762a1$export$7d73f9f8afee3edd = (option)=>$4dd7cabfb97762a1$var$OptionToEventActionSubjectIdMap.get(option) || '';
const $4dd7cabfb97762a1$export$4cbfed6bd1204375 = 'copySpacePermissionsSourceSpaceSelected';
const $4dd7cabfb97762a1$export$63856a579338aaa8 = 'copySpacePermissionsApplyPermissions';
const $4dd7cabfb97762a1$export$8ba837500fb31309 = 'spacePermissionsRestoreDefaults';
const $4dd7cabfb97762a1$export$72e9e37bbaf0a2c3 = 'copySpacePermissionsCancelApply';
const $4dd7cabfb97762a1$export$96a59ca17b6762f0 = 'copySpacePermissionsConfirmApply';
const $4dd7cabfb97762a1$export$5edee710fd3e881c = (createAnalyticsEvent, actionSubject, actionSubjectId)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId
        }
    }).fire();
};
module.exports["OPTION_SELECT_ACTION_SUBJECT"] = $4dd7cabfb97762a1$export$c2f50b86729b5b74;
module.exports["SOURCE_SPACE_SELECT_ACTION_SUBJECT"] = $4dd7cabfb97762a1$export$fedfc172a3b39723;
module.exports["BUTTON_ACTION_SUBJECT"] = $4dd7cabfb97762a1$export$79fc012ce0853550;
module.exports["OPTION_SELECT_DROPDOWN_OPEN_ACTION_SUBJECT_ID"] = $4dd7cabfb97762a1$export$44e673763b6e05ef;
module.exports["getEventActionSubjectId"] = $4dd7cabfb97762a1$export$7d73f9f8afee3edd;
module.exports["SOURCE_SPACE_SELECTED_SUBJECT_ID"] = $4dd7cabfb97762a1$export$4cbfed6bd1204375;
module.exports["APPLY_PERMS_ACTION_SUBJECT_ID"] = $4dd7cabfb97762a1$export$63856a579338aaa8;
module.exports["RESTORE_DEFAULT_PERMS_ACTION_SUBJECT_ID"] = $4dd7cabfb97762a1$export$8ba837500fb31309;
module.exports["APPLY_PERMS_CANCEL_ACTION_SUBJECT_ID"] = $4dd7cabfb97762a1$export$72e9e37bbaf0a2c3;
module.exports["APPLY_PERMS_CONFIRM_ACTION_SUBJECT_ID"] = $4dd7cabfb97762a1$export$96a59ca17b6762f0;
module.exports["fireUIClickEvent"] = $4dd7cabfb97762a1$export$5edee710fd3e881c;

});

parcelRegister("crGnL", function(module, exports) {

var $euL71 = parcelRequire("euL71");

var $e44d7192d4830fcb$export$36d18380658d5d20 = /*#__PURE__*/ function(Option) {
    Option["ONLY_VISIBLE_TO_ME"] = "OnlyVisibleToMe";
    Option["DEFAULT_PERMISSIONS"] = "DefaultPermissions";
    Option["COPY_PERMISSIONS_FROM_ANOTHER_SPACE"] = "CopyPermissionsFromAnotherSpace";
    return Option;
}({});
const $e44d7192d4830fcb$var$OPTIONS_BY_EDITION = {
    [(0, $euL71.ConfluenceEdition).FREE]: [
        "DefaultPermissions"
    ],
    [(0, $euL71.ConfluenceEdition).STANDARD]: [
        "DefaultPermissions",
        "OnlyVisibleToMe"
    ],
    [(0, $euL71.ConfluenceEdition).PREMIUM]: [
        "DefaultPermissions",
        "CopyPermissionsFromAnotherSpace",
        "OnlyVisibleToMe"
    ]
};
function $e44d7192d4830fcb$export$8f569d426f861ccc(edition) {
    switch(edition){
        case (0, $euL71.ConfluenceEdition).PREMIUM:
        case (0, $euL71.ConfluenceEdition).STANDARD:
            return $e44d7192d4830fcb$var$OPTIONS_BY_EDITION[edition];
        case (0, $euL71.ConfluenceEdition).FREE:
        default:
            return $e44d7192d4830fcb$var$OPTIONS_BY_EDITION[(0, $euL71.ConfluenceEdition).FREE];
    }
}
module.exports["Option"] = $e44d7192d4830fcb$export$36d18380658d5d20;
module.exports["getOptionsByEdition"] = $e44d7192d4830fcb$export$8f569d426f861ccc;

});

parcelRegister("gxbof", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cHKtk = parcelRequire("cHKtk");


var $euL71 = parcelRequire("euL71");


var $gLeLL = parcelRequire("gLeLL");

const $bf3e625c36397126$export$a5bc4eb407ffa75f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    let messages;
    let props;
    if ($[0] !== t0) {
        ({ messages: messages, ...props } = t0);
        $[0] = t0;
        $[1] = messages;
        $[2] = props;
    } else {
        messages = $[1];
        props = $[2];
    }
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(props.source);
    let t1;
    if ($[3] !== messages.title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), messages.title);
        $[3] = messages.title;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== messages.body) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...messages.body,
            tagName: "p"
        });
        $[5] = messages.body;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            actionSubjectId: "copySpacePermissionsUpsellLearnMore",
            href: "https://support.atlassian.com/confluence-cloud/docs/copy-space-permissions/"
        };
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== loading || $[9] !== props || $[10] !== showRequestUpgradeButton || $[11] !== t1 || $[12] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
            ...props,
            title: t1,
            body: t2,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton,
            learnMoreLink: t3,
            upgradeEditionActionSubjectId: "copySpacePermissionsUpsellTryNow",
            withGradient: false
        }));
        $[8] = loading;
        $[9] = props;
        $[10] = showRequestUpgradeButton;
        $[11] = t1;
        $[12] = t2;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ messages: messages, ...props })=>{
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(props.source);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gLeLL.SectionMessage), {
        ...props,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), messages.title),
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            ...messages.body,
            tagName: "p"
        }),
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        learnMoreLink: {
            actionSubjectId: 'copySpacePermissionsUpsellLearnMore',
            href: 'https://support.atlassian.com/confluence-cloud/docs/copy-space-permissions/'
        },
        upgradeEditionActionSubjectId: "copySpacePermissionsUpsellTryNow",
        withGradient: false
    }));
};
module.exports["CopySpacePermissionsUpsell"] = $bf3e625c36397126$export$a5bc4eb407ffa75f;

});

parcelRegister("lsPeB", function(module, exports) {
/* SourceSpaceSelector.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $caYQd = parcelRequire("caYQd");


var $4xjqG = parcelRequire("4xjqG");

const $43a6135eb3098c87$export$a7357cdd1f0b0168 = (0, $h82at.defineMessages)({
    sourceSpaceValidationError: {
        id: "copy-space-permissions.option-select.source-space.validation-error",
        defaultMessage: "This space can\u2019t be used as a source."
    },
    sourceSpaceGuestsWarning: {
        id: "copy-space-permissions.option-select.source-space.guests-warning",
        defaultMessage: "The guests in this space won\u2019t be included because guests can only have access to one space at a time."
    }
});
const $43a6135eb3098c87$export$657dee6d5648750a = {
    isRestricted: false,
    containsExternalCollaborators: false,
    spaceKey: '',
    spaceName: '',
    isAdmin: false
};
const $43a6135eb3098c87$export$9973d23b8b5c1744 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isErrorMessage: isErrorMessage, isExtraTall: isExtraTall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isErrorMessage ? "_syaz1tmw" : "_syazn7od",
            __cmplp.isExtraTall ? "_1tket9kd" : "_1tkegktf",
            __cmplp.className
        ])
    });
});
const $43a6135eb3098c87$export$5f8003bf5fd36aef = ({ label: label, onChange: onChange, filterSourceSpaceOptions: filterSourceSpaceOptions, placeholder: placeholder, validationState: validationState = 'default', renderGuestsWarning: renderGuestsWarning = false, fullWidth: fullWidth = false, validationPlaceholder: validationPlaceholder = false, defaultSpaceKey: defaultSpaceKey, allowOnlyAdminSpaces: allowOnlyAdminSpaces, showSpaceLabel: showSpaceLabel = false, labelTextTransform: labelTextTransform })=>{
    const [selection, setSelection] = (0, $42omo.useState)($43a6135eb3098c87$export$657dee6d5648750a);
    const onChangeInternal = (newSelection)=>{
        setSelection(newSelection);
        onChange(newSelection);
    };
    const errorMessage = validationState === 'error' ? $43a6135eb3098c87$export$a7357cdd1f0b0168.sourceSpaceValidationError : null;
    const infoMessage = renderGuestsWarning && selection.containsExternalCollaborators ? $43a6135eb3098c87$export$a7357cdd1f0b0168.sourceSpaceGuestsWarning : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xjqG.SelectLabel), {
        htmlFor: "copy-space-perms-space-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: (0, $4xjqG.selectStyles)(fullWidth)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caYQd.SpaceSelector), {
        id: "copy-space-perms-space-select",
        onChange: onChangeInternal,
        placeholder: placeholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), placeholder),
        showDefaultSpace: false,
        showSpaceLabel: showSpaceLabel,
        validationState: validationState,
        filterOption: filterSourceSpaceOptions,
        spaceKey: defaultSpaceKey,
        allowOnlyAdminSpaces: allowOnlyAdminSpaces,
        lazyLoadOptions: true,
        labelTextTransform: labelTextTransform
    })), label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4xjqG.SelectLabel), null), (validationPlaceholder || errorMessage || infoMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43a6135eb3098c87$export$9973d23b8b5c1744, {
        id: "copy-space-perms-space-select-validation-message",
        style: (0, $4xjqG.selectStyles)(fullWidth),
        isExtraTall: validationPlaceholder && renderGuestsWarning,
        isErrorMessage: !!errorMessage
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), errorMessage), !errorMessage && infoMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), infoMessage)));
};
module.exports["i18n"] = $43a6135eb3098c87$export$a7357cdd1f0b0168;
module.exports["EMPTY_SPACE"] = $43a6135eb3098c87$export$657dee6d5648750a;
module.exports["ValidationMessage"] = $43a6135eb3098c87$export$9973d23b8b5c1744;
module.exports["SourceSpaceSelector"] = $43a6135eb3098c87$export$5f8003bf5fd36aef;

});

parcelRegister("4xjqG", function(module, exports) {
/* LabeledSelect.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0cad5bb3c9b9cbab$export$365377be1492ee64 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $0cad5bb3c9b9cbab$export$f67338d29bd972f8 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4r6c2 _1e0c1o8l _2hwxpxbi _y3gnusic _1bsb1j4a _slp31hna",
            __cmplp.className
        ])
    });
});
const $0cad5bb3c9b9cbab$export$70a9ea0b017c448a = (fullWidth)=>({
        display: 'inline-block',
        width: fullWidth ? '100%' : '300px'
    });
const $0cad5bb3c9b9cbab$export$1c6948252e0c8a0d = (fullWidth)=>({
        container: (provided)=>({
                ...provided,
                ...$0cad5bb3c9b9cbab$export$70a9ea0b017c448a(fullWidth)
            })
    });
module.exports["LabeledSelect"] = $0cad5bb3c9b9cbab$export$365377be1492ee64;
module.exports["SelectLabel"] = $0cad5bb3c9b9cbab$export$f67338d29bd972f8;
module.exports["selectStyles"] = $0cad5bb3c9b9cbab$export$70a9ea0b017c448a;
module.exports["customSelectStyles"] = $0cad5bb3c9b9cbab$export$1c6948252e0c8a0d;

});


//# sourceMappingURL=CopySpacePermissionsForLegacyNewSpace.e19c566d.js.map
